module.exports = __webpack_public_path__ + "img/rw2.8df3d210.png";